import React, { Component } from 'react';
import { Row, Col, List } from 'reactstrap';
import PropTypes from 'prop-types';

import Body from '../Components/layout/Body';
import ReviewRow from '../Components/layout/ReviewRow';
import { PLATFORM_BUTTONS } from './ConstPlatformBtns';
import { isActivityLowTech } from './ConstActivityBtns';
import { SUBTABS, HISTORY_STEPS } from './ConstPaths';
import './Views.scss';

//the props should have been picked before getting to review,
//so make them all required (except name, which is always optional)
const propTypes = {
  firstName: PropTypes.string,
  hasCurrentMethod: PropTypes.string.isRequired,
  currentMethods: PropTypes.arrayOf(PropTypes.object).isRequired,
  pastMethods: PropTypes.arrayOf(PropTypes.object).isRequired,
  platformsUsed: PropTypes.arrayOf(PropTypes.string).isRequired,
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
};

//content sub-component with unique content for this page
function HistoryReviewContent(props) {
  const priority = props.priority;
  const hasCurrentMethod = props.hasCurrentMethod;
  const currentMethods = props.currentMethods;
  const pastMethods = props.pastMethods;
  const platformsUsed = props.platformsUsed;

  console.log("rendering GatherInfoHistoryReviewForm");

  let skipPlatforms = isActivityLowTech(priority);

  const BASE_URL = SUBTABS.HISTORY + "/";
  const steps = HISTORY_STEPS;

  //extract the names from the method arrays, into array of strings
  const cmNames = currentMethods.map(method => method.name);
  const pmNames = pastMethods.map(method => method.name);

  const BINARY_LABELS = [ 
    {
      value: 'true',
      label: 'yes',
    },
    {
      value: 'false',
      label: 'no'
    }
  ];

  return(
  <Row>
    <Col>
      <ReviewRow 
        heading="Has a Current Method" 
        nextRoute={BASE_URL+steps.CURRENT}
        values={hasCurrentMethod}
        lookup={BINARY_LABELS}
      />
      {(hasCurrentMethod==='true') ? 
      <ReviewRow 
        heading="Current Methods" 
        nextRoute={BASE_URL+steps.CURRENT_METHODS}
        values={cmNames}
        lookup={null}
      />
      : <span></span>}
      <ReviewRow 
        heading="Past Methods" 
        nextRoute={BASE_URL+steps.PAST_METHODS}
        values={pmNames}
        lookup={null}
      />
      <ReviewRow 
        heading="Platforms Used" 
        nextRoute={BASE_URL+steps.PLATFORMS}
        values={platformsUsed}
        lookup={PLATFORM_BUTTONS}
        skipWarning={skipPlatforms}
      />
    </Col>
    <Col lg={2}></Col>
  </Row>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component.
//since the main goal step includes a form, receive the initial form values via props,
//along with setters to change those values based on the form input.
function GatherInfoHistoryReview(props) {
  const firstName = props.firstName;
  const priority = props.priority;
  const hasCurrentMethod = props.hasCurrentMethod;
  //TODO ultimately we will be showing a piece of these Methods objects
  const currentMethods = props.currentMethods;
  const pastMethods = props.pastMethods;
  const platformsUsed = props.platformsUsed;
  const onContinue = props.onContinue;

  console.log("rendering GatherInfoHistoryReview");

  let title = `Review ${firstName}'s History of Tech Use`;

  if (isActivityLowTech(priority)){
    title = `Review ${firstName}'s History with Low-tech Access`;
  }

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used
    faIcon: "fa-clock-o",
    pageSymbolClassName: "aa-section-symbol gather",

    title: title,
    subTitle: "Great job! We've visited all sections on History. Here's what we've got:",
    learnMore: {linkText: "",
                title: "",
                content: ""
                },
    nextRoute: "", //not used since we have an onContinue callback
    sidebar: false
  }

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <HistoryReviewContent 
          priority={priority}
          hasCurrentMethod={hasCurrentMethod} 
          currentMethods={currentMethods} 
          pastMethods={pastMethods}
          platformsUsed={platformsUsed}
        />
      }
      onContinue={onContinue} 
    />
    </>
  );
}

GatherInfoHistoryReview.propTypes = propTypes;
GatherInfoHistoryReview.defaultProps = defaultProps;

export default GatherInfoHistoryReview;